import React from 'react'
import {Link} from 'react-router-dom';

const PageTitle = ({ originPath, originPathName, sensorName }) => {
  return (
    <div className='pagetitle'>
      <h1>{sensorName}</h1>
      <nav>
        <ol className='breadcrumb'>
          <li className='breadcrumb-item'>
            <Link to={originPath}>{originPathName}</Link>
          </li>
          {/* <li className='breadcrumb-item'>Binaries</li> */}
          <li className='breadcrumb-item active'>{sensorName}</li>
        </ol>
      </nav>
    </div>
  );
};

export default PageTitle